import ClientBase from './base';

const ClientPackages = <TBase extends Constructor<ClientBase>>(superclass: TBase) =>
  class extends superclass {};

export default ClientPackages;
